import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const CarouselContainer = styled.div`
  margin: ${toRem(55)} 0;

  .card-eyebrow {
    border-radius: 20px;
    width: 50%;
    height: ${toRem(16)};
    margin-bottom: 8px;
    z-index: 1000;
  }

  .card-text {
    border-radius: 20px;
    width: 100%;
    height: ${toRem(32)};
    z-index: 1000;
  }

  .skeleton-details {
    display: grid;
    grid-template-rows: auto 1fr auto;
    padding: 24px;
  }

  .skeleton-card-content {
    grid-row: 3;
  }
`;

export const CarouselElementContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${toRem(24)};

  .wide {
    width: 100%;
    height: ${toRem(174)};

    @media (min-width: 430px) {
      height: ${toRem(200)};
    }

    @media ${baseVariables.mediaQuery.md} {
      height: ${toRem(184)};
    }

    @media (min-width: 1024px) {
      height: ${toRem(252)};
    }

    @media ${baseVariables.mediaQuery.xl} {
      height: ${toRem(302)};
    }
  }

  .skeleton-loader-composite {
    border-radius: 0.9375rem;
  }
`;

export const MobileCarouselElementContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1rem;
  gap: ${toRem(24)};

  .square {
    height: ${toRem(344)};
    width: ${toRem(344)};

    @media (min-width: 360px) {
      height: ${toRem(328)};
      width: ${toRem(328)};
    }

    @media (min-width: 430px) {
      height: ${toRem(365)};
      width: ${toRem(365)};
    }

    @media ${baseVariables.mediaQuery.md} {
      height: ${toRem(328)};
      width: ${toRem(328)};
    }

    @media (min-width: 1024px) {
      height: ${toRem(448)};
      width: ${toRem(448)};
    }

    @media ${baseVariables.mediaQuery.xl} {
      height: ${toRem(261)};
      width: ${toRem(261)};
    }
  }

  .skeleton-loader-composite {
    border-radius: 0.9375rem;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  margin-bottom: ${toRem(16)};
  align-items: center;
  justify-content: center;
  @media (max-width: 767px) {
    align-items: flex-start;
    padding: 0 1rem;
  }
  flex-direction: column;
  .carousel-heading,
  .carousel-subheading {
    border-radius: 20px;
    margin-bottom: ${toRem(16)};
  }

  .carousel-heading {
    height: ${toRem(32)};
    width: 40%;
    @media (max-width: 767px) {
      width: 80%;
    }
  }

  .carousel-subheading {
    height: ${toRem(16)};
    width: 30%;
    @media (max-width: 767px) {
      width: 70%;
    }
  }
`;
